export default {
  darkMode(state) {
    return state.darkMode
  }
}
